import { Outlet } from "react-router-dom";
import Footer from "../components/Footer";
// import AdminNavBar from "../components/admin/common/AdminNavBar";
import Navbar from "../components/Navbar";

const PublicLayout = () => {
  return (
    <div className="flex font-poppins flex-col min-h-screen bg-gray-50 relative">
      <Navbar />
      {/* <AdminNavBar /> */}
      <main className="flex-1 mt-16 sm:mt-18 md:mt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
